import { render, staticRenderFns } from "./LessonThumb.vue?vue&type=template&id=fa072704&scoped=true&"
import script from "./LessonThumb.vue?vue&type=script&lang=js&"
export * from "./LessonThumb.vue?vue&type=script&lang=js&"
import style0 from "./LessonThumb.vue?vue&type=style&index=0&id=fa072704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa072704",
  null
  
)

export default component.exports